/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { AppState } from '@app/core/types';
import { createReducer, on } from '@ngrx/store';
import { metricDefsAction } from './metric-definition.actions';

export const metricDefsReducer = createReducer<AppState['metricDefs']>(
  {},
  on(metricDefsAction, (state, action) => {
    const clusterDefsState = {
      ...state[action.clusterId],
      ...Object.fromEntries(action.data.map((metricDefinition) => [metricDefinition.id, metricDefinition])),
    };

    return {
      ...state,
      [action.clusterId]: clusterDefsState,
    };
  }),
);
